import React from 'react';
import classes from './Blogs.module.css';

const Blogs = () => {
  return <div>Blogs</div>;
};

export default Blogs;
